/**
 * Note: For any new order event type created please add it to the Types array as well.
 * MOVE TO PER APP SERVICE
 */
export const ORDER_EVENT_TYPE = {
	ORDER_CREATED: 'order.created',
	ORDER_REJECTED: 'order.rejected',
	ORDER_APPROVED: 'order.approved',
	ORDER_RESUBMITTED: 'order.resubmitted',
	ORDER_SUBSCRIBED: 'user.subscribed',
	ORDER_UNSUBSCRIBED: 'user.unsubscribed',
	ORDER_RULES_FORCE_EXECUTION_CI: 'order.rulefired', // INvision ClassIntelligence
	ORDER_RULES_FORCE_EXECUTION: 'order.rulesexecuted', // Desktop & future
	ORDER_RULES_CHANGED: 'rule.changed',
	ORDER_RULES_SSR_RULESREADY: 'order.ssrrulesready',
	ORDER_LOCKED: 'order.locked',
	ORDER_UNLOCKED: 'order.unlocked',
	ORDER_ZIPREADY: 'order.zipready',
	QRR_REPORT_GENERATED: 'order.qrr.attachmentready',
	ORDER_UPDATED_BY_SERVER: 'order.updatedbyserver',
	ORDER_DOCUMENT_READY: 'order.documentready',
	ORDER_DOCUMENT_FAILED: 'order.documentfailed',
	ORDER_GSE_VALIDATION_RESULT: 'order.gseValidationResult',
	ORDER_GSE_FAILED: 'order.gsefailed',
	ORDER_GSE_READY: 'order.gseready',
	ORDER_ACTION_REQUIRED: 'order.action_required'
};

export const GENERAL_EVENT_TYPE = {
	UNSUBSCRIBE: 'Unsubscribe',
	MEMBERS: 'Members',
	USER_DISCONNECTED: 'user.disconnected'
};

export const ORDER_EVENT_TYPES = [
	ORDER_EVENT_TYPE.ORDER_APPROVED,
	ORDER_EVENT_TYPE.ORDER_REJECTED,
	ORDER_EVENT_TYPE.ORDER_CREATED,
	ORDER_EVENT_TYPE.ORDER_RESUBMITTED
];

export enum ORDER_EVENT_ACTION {
	REMOVE_ORDER = 'order.removed',
 	NEW_ORDER = 'order.new',
 	VIEWED_ORDER = 'order.viewed'
}
